import {
  IPageContent,
  IPageCover,
  IPageEnd,
  IPageGift,
  IPagePromo,
  IPageRecord,
  PhysicalGiftType,
  VirtualGiftType,
} from 'lib/provider/services/data-adapter/types';
import type { IOriginDataPageMessage, IOriginDataPagePromo } from 'lib/provider/requests/data/types';

export const isVirtualGiftPage = (page: IPageGift | any): page is IPageGift<VirtualGiftType> => (
  page?.type === 'PageGift' && 'gift' in page.items && page.items.gift?.type === 'virtual'
);

export const isPhysicalGiftPage = (page: IPageGift | any): page is IPageGift<PhysicalGiftType> => (
  page?.type === 'PageGift' && 'gift' in page.items && page.items.gift?.type === 'physical'
);

export const isCoverPage = (page: any): page is IPageCover => (
  page?.type === 'PageCover'
);

export const isContentPage = (page: any): page is IPageContent => (
  page?.type === 'PageContent'
);

export const isRecordPage = (page: any): page is IPageRecord => (
  page?.type === 'PageRecord'
);

export const isPromoPage = (page: any): page is IPagePromo => (
  page?.type === 'PagePromo'
);

export const isEndPage = (page: any): page is IPageEnd => (
  page?.type === 'PageEnd'
);

export const isVirtualGift = (gift: any): gift is VirtualGiftType => (
  gift?.type === 'virtual'
);

export const isPhysicalGift = (gift: any): gift is PhysicalGiftType => (
  gift?.type === 'physical'
);

export const isOriginCoverPage = (data: IOriginDataPageMessage | any): data is IOriginDataPageMessage => (
  data.type === 'cover'
);

export const isOriginMessagePage = (data: IOriginDataPageMessage | any): data is IOriginDataPageMessage => (
  data.type === 'message'
);

export const isOriginPromoPage = (data: IOriginDataPagePromo | any): data is IOriginDataPagePromo => (
  ['promo_ad', 'action', 'promo_ad_user'].includes(data.type)
);
